















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { User } from "@/components/User";
import { isObject } from "@/common/utils";

@Component({
  watch: {
    type(val) {
      if (val=='calendar') {
        this.ContentClass = 'this-dialog calendar';
      } else {
        this.ContentClass = 'this-dialog';
      }
    },
    show(val) {
      if (val) {
        let $this = this;
        setTimeout(() => {
          if ($this.$refs.focusMe) {
            (<HTMLElement> this.$refs.focusMe).focus();
          }
        },0); //ensure that this has been mounted
        if (this.type=='form' && !!this.message) {
          this.FormData = <{[key:string] : any}[]> this.message;
        }
      }
    }
  }
})
export default class DialogUI extends Vue {
  @Prop({
    default: 'info',
    required: false
  }) type: string; //"info" | "error" | "alert" | "login" | "form" | "calendar" | "html" | "alert-html"
  @Prop({
    default: null
  }) width: number;
  @Prop({
    default: false
  }) show: boolean;
  @Prop({
    default: false
  }) wait: boolean;
  @Prop({
    default: false
  }) disableOk: boolean
  @Prop({
    default: null
  }) ok:string;
  @Prop({
    default: 'close'
  }) cancel:string;
  @Prop({
    default: null
  }) title:string;
  @Prop({
    default: null,
    required: false
  }) message: any; //string[] | {[key:string] : any}[] | string;

  FormData : {[key:string] : any}[] = [];
  ContentClass: string = 'this-dialog';

  get locale() : string {
    return this.$store.getters.Locale;
  };

  get TypeTheme() : string {
    let theme;
    if (this.type=='info' && !this.errorMessage) {
      theme = 'dark'
    } else {
      theme = 'light'
    }
    return theme;
  }

  get TypeIcon() : string {
    let icon;
    let type = this.type + '';
    if (!!this.errorMessage || type.match(/^error/i)) {
      icon = 'mdi-alert-box theme--dark';
    } else if (type.match(/^alert/i)) {
      icon = 'mdi-alert theme--dark';
    } else if (type=='login') {
      icon = 'mdi-lock theme--dark';
    } else {
      icon = 'mdi-information';
    }
    return icon;
  }

  get TypeColor() : string {
    let color;
    let type = this.type + '';
    if (!!this.errorMessage || type.match(/^error/i)) {
      color = 'red white-text';
    } else if (type.match(/^alert/i)) {
      color = 'orange white-text';
    } else if (type=='login') {
      color = 'primary white-text';
    } else {
      color = 'grey lighten-2 black-text';
    }
    return color;
  }

  get showMe() : boolean {
    return this.show || this.wait;
  }
  
  private username: string = '';
  private password: string = '';
  private errorMessage: string = null;

  datePicker = new Date().toISOString().substr(0, 10);
  
  async login() {
    try {
      let user = new User();
      let ok = await user.login(this.username, this.password);
      this.$store.commit('notifyChange', {
        User: user
      });
      this.$emit('close', 'ok');
    } catch (error) {
      this.errorMessage = error.message || 'loginWasNotSuccessful';
    }
  }
  
  doAction(action:"ok" | "close" | "cancel") {
    if (action=='ok' && this.type=='login') {
      this.login();
    } else if (this.type=='calendar') {
      this.$emit('close', {
        action: action,
        date: this.datePicker
      });
    } else {
      this.$emit('close', action);
    }
  }
}
